import React, { useContext } from 'react';

const RecordContext = React.createContext(null);

export default RecordContext;

export function useRecordContext() {
    return useContext(RecordContext);
}
